module.exports = __webpack_public_path__ + "static/3-46c4fa14c0f4c6227e9dcac08d241323.jpg";